import { TextV2 } from '@withjoy/joykit';
import { LayoutAddComponentListItem } from '../../../../../LeftPanelLayouts/LayoutAddComponentListItem';
import { useCreateNewJsonComponent } from '../../../hooks/useJsonBlobStorageUtils';
import React from 'react';
import { Calendar } from '@withjoy/joykit/icons';
import { AdminSidebarComponentProps } from '../../../JsonComponent.types';
import { SimpleGrabHandle } from '../../SimpleGrabHandle';
import { GeneralScheduleConfig } from './GeneralSchedule.config';
import { useNavigationPaneContext } from '@apps/admin/routes/WebsiteEditor/context/NavigationPaneContext/NavigationPane.context';
import { useUpdateWebsitePreview } from '@apps/admin/routes/WebsiteEditor/hooks/useUpdateWebsitePreview';
import { useCustomComponentStateContext } from '@apps/admin/routes/WebsiteEditor/routes/WebsiteEditorCustomPageV2/context/CustomComponentStateContext/CustomComponentState.context';
import { JsonDataContainerFragment } from '@graphql/generated';
import { CUSTOM_PAGE_ACTIONS } from '../../../../CustomComponents.constants';

// Tip:
// This is the grab handle for your component in the sidebar
// while re-ordering components.
export const GeneralScheduleGrabber = (props: AdminSidebarComponentProps) => {
  return (
    <SimpleGrabHandle
      title={'Event Schedule'}
      icon={<Calendar size={32} />}
      {...props}
    ></SimpleGrabHandle>
  );
};

// Tip:
// This is the button that shows in the "Add Content" page
export const GeneralScheduleAdd = (props: AdminSidebarComponentProps) => {
  const { createNewJsonComponent } = useCreateNewJsonComponent(props.eventHandle);
  const { setRefetchQueries } = useCustomComponentStateContext<JsonDataContainerFragment>();
  const { replaceAndNavigateToScreen } = useNavigationPaneContext();
  const { updateWebsitePreview } = useUpdateWebsitePreview();

  const handleClick = () => {
    createNewJsonComponent({
      schemaURL: GeneralScheduleConfig.schemaUrl,
      type: 'GeneralEventSchedule',
      initialData: {
        displayType: 'two-column',
      },
      containerId: props.containerId,
    }).then(result => {
      if (result?.containerData?.data) {
        // Request a refetch of the components list to update the left panel
        setRefetchQueries(['PageContainerBySlug']);

        // Then update the preview
        updateWebsitePreview();

        // Finally replace and navigate to ensure proper left panel update
        replaceAndNavigateToScreen(CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS);
      }
    });
  };

  return (
    <LayoutAddComponentListItem onClick={handleClick}>
      <Calendar size={48} />
      <TextV2
        typographyVariant="hed2"
        textAlign="left"
      >
        Event Schedule
      </TextV2>
    </LayoutAddComponentListItem>
  );
};
